/** Utilities for sanitizing and converting between Markdown and HTML content in task descriptions. */
import DOMPurify from 'dompurify';
import { marked } from 'marked';

/**
 * Checks if a string contains HTML tags. Not foolproof but sufficient
 * for the migration case from Markdown to HTML.
 * @param {string} str
 * @returns {boolean}
 */
/** @public */
export const isHtml = (str) => {
  if (!str || typeof str !== 'string') return false;
  const htmlRegex = /<[a-z][\s\S]*>/i;
  return htmlRegex.test(str);
};

/**
 * Converts content (Markdown or HTML) to a sanitized HTML string safe for
 * use with dangerouslySetInnerHTML.
 * @param {string} content
 * @returns {string}
 */
export const createSafeHtml = (content) => {
  if (!content) return '';
  const html = isHtml(content)
    ? content
    : /** @type {string} */ (marked(content));
  return DOMPurify.sanitize(html);
};
